import { Link } from 'react-router-dom';

export function MarketingFooter() {
  return (
    <footer className="relative border-t border-white/10 px-5 py-10 text-sm text-slate-500 md:px-8">
      <div className="mx-auto flex max-w-6xl flex-col gap-5 sm:flex-row sm:items-center sm:justify-between">
        <span>RoleForge by VibeControl - Built by Dustin and the Build3r team</span>
        <div className="flex flex-wrap gap-5">
          <a href="/terms" className="transition hover:text-white">Terms</a>
          <a href="/privacy" className="transition hover:text-white">Privacy</a>
          <a href="mailto:hello@build3r.io" className="transition hover:text-white">Contact</a>
          <Link to="/login" className="transition hover:text-white">Login</Link>
        </div>
      </div>
    </footer>
  );
}
